import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { PageGlobalCreditAccounts } from "@src/components/modules/credit-account/global-accounts-listing";
import { NavigationFinance } from "@src/components/widgets/AppSubNav";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout
    title={t`Global credit accounts`}
    navigation={<NavigationFinance />}
  >
    <PageGlobalCreditAccounts />
  </MainLayout>
);

export const Route = createFileRoute("/credit-accounts/global")({
  component: Page,
});
